module.exports = __webpack_public_path__ + "static/media/water-wipes.3d9d3bd1.jpg";